/**
 * @generated SignedSource<<297415957bbf35c7a1817099c57951a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type organizationManagementQuery$variables = Record<PropertyKey, never>;
export type organizationManagementQuery$data = {
  readonly userOrganization: {
    readonly hospitals: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly operatingRooms: {
            readonly " $fragmentSpreads": FragmentRefs<"OperatingRoomManagementFragment">;
          } | null | undefined;
          readonly timezone: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type organizationManagementQuery = {
  response: organizationManagementQuery$data;
  variables: organizationManagementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "organizationManagementQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "userOrganization",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "HospitalConnection",
            "kind": "LinkedField",
            "name": "hospitals",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HospitalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hospital",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": (v4/*: any*/),
                        "concreteType": "LocationConnection",
                        "kind": "LinkedField",
                        "name": "operatingRooms",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "OperatingRoomManagementFragment"
                          }
                        ],
                        "storageKey": "operatingRooms(first:20)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "hospitals(first:10)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "organizationManagementQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "userOrganization",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "HospitalConnection",
            "kind": "LinkedField",
            "name": "hospitals",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HospitalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hospital",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": (v4/*: any*/),
                        "concreteType": "LocationConnection",
                        "kind": "LinkedField",
                        "name": "operatingRooms",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LocationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Location",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "operatingRooms(first:20)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "hospitals(first:10)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4f9a383920182d561236c67d4caad81",
    "id": null,
    "metadata": {},
    "name": "organizationManagementQuery",
    "operationKind": "query",
    "text": "query organizationManagementQuery {\n  userOrganization {\n    id\n    name\n    hospitals(first: 10) {\n      edges {\n        node {\n          id\n          name\n          timezone\n          operatingRooms(first: 20) {\n            ...OperatingRoomManagementFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OperatingRoomManagementFragment on LocationConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1529135e44f2db6e4b4f0ae2c119ba65";

export default node;
